import React, { useState, useMemo, useEffect } from 'react';
import { Box } from '@availity/element';

import { useAppContext } from '@/context';
import { checkNavigation, JOURNEY_FORGOTTEN_USERNAME } from '@/global';
import { useFRStep } from '@/hooks';
import { EmailSent, EnterEmailAddress, ErrorPage } from '@/pages';

const ForgotUserId = () => {
  const { queryParams = {} } = useAppContext();
  const [currentStep, setCurrentStep] = useState();

  const { authIndexValue = '' } = queryParams;

  // process authIndexValue in event that the UI should navigate to a different journey
  const journeyId = useMemo(() => authIndexValue?.toLowerCase(), [authIndexValue]);

  // call utility function to check if we need to navigate to a different route
  useEffect(() => {
    if (journeyId) {
      checkNavigation(journeyId);
    }
  }, [journeyId]);

  // get FR step info from custom hook
  // NOTE: updating the currentStep 'should' trigger fetching of the stepToRender
  // currentStep should be changed on form submission
  const { stepToRender } = useFRStep(currentStep, JOURNEY_FORGOTTEN_USERNAME);

  const pageNodeToRender = useMemo(() => {
    let component;

    if (stepToRender) {
      const { payload = {} } = stepToRender;
      const { callbacks = [], stage } = payload;

      // first check for a suspended text output callback; in this case the email sent node should render
      // a stage name should not be present in this case
      if (callbacks?.length > 0) {
        const callbackToCheck = callbacks[0];

        if (callbackToCheck?.type?.toLowerCase() === 'suspendedtextoutputcallback') {
          component = <EmailSent key="emailSent" stepToRender={stepToRender} />;
        }
      }

      switch (stage) {
        case 'ForgottenUsername001': {
          component = <EnterEmailAddress stepToRender={stepToRender} setCurrentStep={setCurrentStep} />;
          break;
        }
        case 'ForgottenUsername002': {
          component = <EmailSent key="emailSent" stepToRender={stepToRender} />;
          break;
        }
        case 'ErrorPage': {
          component = <ErrorPage key="errorPage" />;
          break;
        }
        default:
      }
    }

    return component;
  }, [stepToRender]);

  return <Box role="main">{pageNodeToRender}</Box>;
};

export default ForgotUserId;
